import React, { FC, memo, ReactElement } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { DataListControl } from 'reactApp/ui/DataListControl/DataListControl';
import { Hint } from 'reactApp/ui/Hint/Hint';

import styles from '../DataListItemRow.css';
import { BasicProps } from '../DataListItemRow.types';

interface CheckboxProps {
    onCheckboxClick: BasicProps['onCheckboxClick'];
    isSelected: boolean;
    isDisabled?: boolean;
    isLarge?: boolean;
}

export const Checkbox: FC<CheckboxProps> = memo(({ onCheckboxClick, isSelected, isDisabled, isLarge }): ReactElement => {
    const textIsSelected = isSelected ? 'Снять выделение' : 'Выделить';
    const hint = !isDisabled ? textIsSelected : '';

    return (
        <Hint text={hint}>
            <div className={styles.check}>
                <DataListControl
                    type="check"
                    active={isSelected}
                    disabled={isDisabled}
                    size={isLarge ? 28 : 24}
                    viewType={EViewMode.list}
                    onClick={onCheckboxClick}
                />
            </div>
        </Hint>
    );
});

Checkbox.displayName = 'Checkbox';
